@if (shouldLoadSubscriptionState()) {
  <app-base-modal
    class="subscription-alert-modal"
    [opened]="opened()"
    [label]="title()"
    [width]="800"
    [minWidth]="520"
    [minHeight]="320"
    [draggable]="true"
    [resizable]="true"
    [renderInBody]="true"
    [overlayZIndex]="1600"
    [closeOnBackdropClick]="false"
    [headerButtons]="['close']"
    [primaryButtonText]="viewUsageButtonLabel()"
    [primaryButtonAction]="viewSubscriptionUsage"
    [secondaryButtonText]="dismissButtonLabel()"
    [secondaryButtonAction]="closeOverlay"
    (closed)="closeOverlay()"
  >
    <div class="subscription-alert-modal__body">
      <div class="subscription-alert-modal__alert" role="alert">
        <div class="subscription-alert-modal__alert-icon" aria-hidden="true">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            focusable="false"
          >
            <circle
              cx="12"
              cy="12"
              r="11"
              stroke="currentColor"
              stroke-width="1.2"
            />
            <path
              d="M12 7v6"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
            />
            <circle cx="12" cy="17" r="0.9" fill="currentColor" />
          </svg>
        </div>
        <p class="subscription-alert-modal__desc">{{ description() }}</p>
      </div>

      @if (overdraftRows().length > 0) {
        <p class="subscription-alert-modal__intro">
          {{ 'components.subscription.usageTable.intro' | transloco }}
        </p>

        <div class="subscription-alert-modal__table">
          <app-base-table class="tw:w-full" [table]="overdraftTableService" />
        </div>
      }
    </div>
  </app-base-modal>
}
